const sliderContainer = document.querySelector('.slider-container');

if (sliderContainer) {
  const spans = sliderContainer.querySelectorAll('span');
  let currentIndex = 0;

  setInterval(() => {
    spans[currentIndex].classList.add('fade-out');

    setTimeout(() => {
      spans[currentIndex].classList.remove('active', 'fade-out');
      currentIndex = (currentIndex + 1) % spans.length;
      spans[currentIndex].classList.add('active');
    }, 50); // Sehr schnelles Ausblenden

  }, 2000);
}